module.exports = __webpack_public_path__ + "media/images/brand/mastercard-0e0f16b8ff60d3770391009bad3e1f1d.png";